import { Tag, Link2, UserPlus, Mail, GraduationCap, ShieldCheck, HelpCircle } from "lucide-react";

/**
 * Where a lead came from — one chip that answers "which campaign, or was it just
 * someone's plain link?". `origin` comes from the API (backend/lead_origin.py).
 */
const STYLE = {
  campaign: { cls: "bg-sky-50 text-sky-700 border-sky-200", Icon: Tag },
  link: { cls: "bg-indigo-50 text-indigo-700 border-indigo-200", Icon: Link2 },
  signup: { cls: "bg-emerald-50 text-emerald-700 border-emerald-200", Icon: UserPlus },
  invite: { cls: "bg-blue-50 text-blue-700 border-blue-200", Icon: Mail },
  academy: { cls: "bg-violet-50 text-violet-700 border-violet-200", Icon: GraduationCap },
  admin: { cls: "bg-black/5 text-ink-2 border-black/10", Icon: ShieldCheck },
  none: { cls: "bg-amber-50 text-amber-800 border-amber-200", Icon: HelpCircle },
};

export const OriginChip = ({ origin, testid, showPage = true }) => {
  if (!origin) return <span className="text-ink-3 text-[11px]">—</span>;
  const { cls, Icon } = STYLE[origin.kind] || STYLE.none;
  const campaign = origin.kind === "campaign";
  const title = [
    campaign ? `Campaign link — ${origin.label}` : origin.label,
    origin.detail,
    origin.page ? `Lands on: ${origin.page}` : null,
  ].filter(Boolean).join("\n");
  return (
    <span className="inline-flex flex-col gap-0.5 min-w-0" title={title} data-testid={testid}>
      <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded border text-[10px] font-bold tracking-wide w-fit max-w-[150px] ${campaign ? "" : "uppercase tracking-wider"} ${cls}`}>
        <Icon size={9} className="shrink-0" />
        <span className="truncate">{origin.label}</span>
      </span>
      {showPage && campaign && (
        <span className="text-[10px] text-ink-3 truncate max-w-[150px]">
          {[origin.utm_source, origin.campaign].filter(Boolean).join(" · ") || origin.page}
        </span>
      )}
    </span>
  );
};

export default OriginChip;
